import { getUserAccessToken } from '@/utils/account/getUserAccessToken';
import { getSearchSuggestions as getSearchSuggestionsServer } from '@/actions/searchSuggestions';

export const getSearchSuggestions = async (description?: string) => {
  const userAccessToken = await getUserAccessToken();
  return getSearchSuggestionsServer(userAccessToken, description ?? '');
};
